import _ from 'underscore';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { getIsLastStep, getWizardData, useWizardService, BasicStepFooter, getCurrentStepId, matchStepState, STEP_STATES, WIZARD_EVENTS } from '@bingads-webui-fluent-component/wizard';
import { LINKEDIN_WIZARD_STEP_PATHS, isAudienceTooNarrow } from '@bingads-webui-campaign-react/linkedin-utils';
import { TermsAndConditions } from './terms-and-conditions';
import { useWizardStyles } from '../styles/wizard-styles';

export const LinkedInStepFooter = (props) => {
  const classes = useWizardStyles();
  const { nextDisabled: nextDisabledFromProps, showTermsAndConditions: showTermsAndConditionsProps } = props;
  const { state, send } = useWizardService();

  const currentStepId = getCurrentStepId(state);
  const { isFirstRun, audienceSize, isMemberTokenRevoked } = getWizardData(state);
  const isLastStep = getIsLastStep(state);

  // If audience is too narrow at the targeting step, we disable the next button
  const audienceTooNarrow = currentStepId === LINKEDIN_WIZARD_STEP_PATHS.TARGETING && _.isNumber(audienceSize) && isAudienceTooNarrow(audienceSize);

  const [areTermsChecked, setAreTermsChecked] = useState(false);

  // During the first run, the user see the terms and conditions
  // on the account linking step. So, we don't require the user to accept it again.
  const termsAccepted = isFirstRun || areTermsChecked;

  const nextDisabled = nextDisabledFromProps || (showTermsAndConditionsProps && isLastStep && !termsAccepted) || isMemberTokenRevoked || audienceTooNarrow;
  const showTermsAndConditions = showTermsAndConditionsProps && isLastStep && !isFirstRun;

  // Reset the cancel button custom action
  useEffect(() => {
    if (!matchStepState(state, STEP_STATES.ACTIVE)) { return; }

    const { onExited } = getWizardData(state);

    if (!onExited) { return; }

    send(WIZARD_EVENTS.UPDATE_WIZARD_DATA, { onExited: undefined });
  }, [state, send]);

  return (
    <div className={classes.footer}>
      {showTermsAndConditions && (
        <TermsAndConditions checked={areTermsChecked} onChange={setAreTermsChecked} />
      )}
      <BasicStepFooter {...props} useCancelButton nextDisabled={nextDisabled} />
    </div>
  );
};

LinkedInStepFooter.propTypes = {
  nextDisabled: PropTypes.bool.isRequired,
  showTermsAndConditions: PropTypes.bool,
};

LinkedInStepFooter.defaultProps = {
  showTermsAndConditions: true,
};
